const downloadHelper = (urls = [], intervalTime = 300) => {
  let interval;
  const allUrls = [...urls];
  const download = () => {
    const url = allUrls.pop();
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', '');
    a.setAttribute('target', '_blank');
    a.click();

    if (allUrls.length === 0) {
      clearInterval(interval);
      interval = undefined;
    }
  };
  interval = setInterval(download, intervalTime);
};

export default downloadHelper;
